import { render, staticRenderFns } from "./Medical_2.vue?vue&type=template&id=69943e8e&scoped=true"
import script from "./Medical_2.vue?vue&type=script&lang=js"
export * from "./Medical_2.vue?vue&type=script&lang=js"
import style0 from "./Medical_2.vue?vue&type=style&index=0&id=69943e8e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69943e8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69943e8e')) {
      api.createRecord('69943e8e', component.options)
    } else {
      api.reload('69943e8e', component.options)
    }
    module.hot.accept("./Medical_2.vue?vue&type=template&id=69943e8e&scoped=true", function () {
      api.rerender('69943e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/Medical_2.vue"
export default component.exports